import { RJSFSchema, StrictRJSFSchema, WidgetProps } from '@rjsf/utils';
import { useMemo } from 'react';

import ReactSelect, { OptionType } from 'dashboard/components/ReactSelect';

/** The `SelectWidget` is a widget for rendering dropdowns.
 *  It is typically used with string properties constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */
export function SelectWidget<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>({
  schema,
  id,
  options,
  value,
  required,
  disabled,
  readonly,
  multiple = false,
  autofocus = false,
  onChange,
  placeholder,
}: /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
WidgetProps<T, S, F>) {
  const { enumOptions, enumDisabled } = options;
  const emptyValue: any[] | string = multiple ? [] : '';

  const reactSelectOptions = useMemo(() => {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const options: OptionType[] = enumOptions.map(({ value, label }) => ({
      value,
      label,
      disabled: enumDisabled && enumDisabled.indexOf(value) !== -1,
    }));

    if (!multiple && schema.default == null) {
      options.unshift({
        label: placeholder || 'Select...',
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        value: undefined,
      });
    }

    return options;
  }, [enumOptions, enumDisabled, multiple, placeholder, schema.default]);

  return (
    <ReactSelect
      id={`${id}-container`}
      inputId={id} // this associated the label correctly with the input nested within React Select
      name={id}
      value={typeof value === 'undefined' ? emptyValue : value}
      required={required}
      disabled={disabled || readonly}
      autoFocus={autofocus}
      onChange={onChange}
      options={reactSelectOptions}
      isMulti={multiple}
    />
  );
}
